import { useEffect, useState } from 'react'
import useCallApi from '../../utilities/axios'
import * as umServiceURL from './umServiceURL'

export type UplodeFileDocType = {
    uploadFileObj: {
        fileList: {
            replaceFileID: number | null
            fileID: number | null
            fileToken: string | null
            filename: string | null
            path: string
            date: string
        }[]
    }
}

export type FormType = {
    username: string
    password: string
    nameTH: string
    nameEN: string
    homeTelephone: string
    mobilePhone: string
    usergroupID: number
    title: lookUps
    position: lookUps
    irb: number
    isPhD: boolean
    cunet: boolean
    titleOtherTH?: string
    titleOtherEN?: string
    titleID?: string
    positionOtherTH?: string
    positionOtherEN?: string
    positionID?: string
    cunetID?: string
    personnelId?: string
    isBothIrb: boolean
    documentInfo: UplodeFileDocType[]
    updateBy: string
}

export type FormInitial = {
    username?: string
    nameTH?: string
    nameEN?: string
    homePhone?: string
    homeTelephone?: string
    mobilePhone?: string
    usergroupID?: number
    irb?: number | null
    isPhD?: boolean
    cunet?: string
    titleID?: string
    positionID?: string
    cunetID?: string
    positionOtherTH?: string
    positionOtherEN?: string
    titleOtherTH?: string
    titleOtherEN?: string
    title?: lookUps
    position?: lookUps
    signatureTH: string | null
    signatureEN: string | null
    isBothIrb: boolean
    documentInfo: UplodeFileDocType[]
    updateBy: string
}

type lookUps = {
    id?: number | string
    name: {
        th?: string
        en?: string
    }
}

const useEditUsergroup = (id: string) => {
    const callApi = useCallApi()
    const [officerInfo, setOfficer] = useState<FormInitial>()

    useEffect(() => {
        if (id !== 'undefined') {
            getOfficer(id)
        }
    }, [])
    const putOfficer = async (values: FormType, userID: string) => {
        const { data } = await callApi.axiosPut<any>({
            url: `${umServiceURL.postAddOfficer}/${userID}`,
            params: values,
        })

        return data
    }

    const getOfficer = async (userID: string) => {
        const { data } = await callApi.axiosGet<any>({
            // url: `${umServiceURL.getAddOfficer}/${userID}`,
            url: `${umServiceURL.getUserInfo}/${userID}`,
        })
        setOfficer(data)
        return data
    }

    return { putOfficer, officerInfo }
}

export default useEditUsergroup
